import {
  DATALAYER_NAME,
} from '@js/src/base-functions';

/* eslint-disable */
/**
 * NOTE: this file was created manually and copies over source code of original vendor code from:
 * - template-parts/blocks/polls/assets/js/closest-polyfill.js
 * - template-parts/blocks/polls/assets/js/transpiledCode.js
 */

/*
 * closest-polyfill.js
 */
if (window.Element && ! Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var matches = (this.document || this.ownerDocument).querySelectorAll(s),
			i,
			el = this;
		do {
			i = matches.length;
			while (--i >= 0 && matches.item(i) !== el) {}
		} while ((i < 0) && (el = el.parentElement));
		return el;
	};
}


/*
 * transpiledCode.js
 */
document.addEventListener('DOMContentLoaded', function(event){

  "use strict";

  function _instanceof(left, right){
    if (
      right != null &&
      typeof Symbol !== "undefined" &&
      right[Symbol.hasInstance]
    ) {
      return !!right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  }

  function _classCallCheck(instance, Constructor){
    if (!_instanceof(instance, Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props){
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) {
        descriptor.writable = true;
      }
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps){
    if (protoProps) {
      _defineProperties(Constructor.prototype, protoProps);
    }
    if (staticProps) {
      _defineProperties(Constructor, staticProps);
    }
    return Constructor;
  }

  var msdAcfPoll = /*#__PURE__*/ (function(){
    var has_voted = false; // control var to prevent button click

    function msdAcfPoll(){
      _classCallCheck(this, msdAcfPoll);

      this.response = [];
      this.prefix = "poll";
      this.mpoll = document.querySelector("#poll-modal");
      this.polls = document.querySelectorAll(".poll-widget");
      this.element = {};
      this.name = {
        parent : this.prefix,
        modal : "".concat(this.prefix, "-modal"),
        widget : "".concat(this.prefix, "-widget"),
        wrapper : "".concat(this.prefix, "-wrapper"),
        question : "".concat(this.prefix, "-question"),
        list : "".concat(this.prefix, "-choices"),
        choice : "".concat(this.prefix, "-choice"),
        footer : "".concat(this.prefix, "-footer"),
        message : "".concat(this.prefix, "-message"),
        total : "".concat(this.prefix, "-total"),
        voteButton : "".concat(this.prefix, "-vote"),
        viewButton : "".concat(this.prefix, "-view"),
        closeButton : "".concat(this.prefix, "-close"),
        loader : "".concat(this.prefix, "-loader"),
        events : false
      };
      this.submitVote = this.submitVote.bind(this);
      this.preparePolls();
    }

    _createClass(msdAcfPoll, [
      {
        key : "preparePolls",
        value : function preparePolls(){
          var _this = this;

          var promisses = [];

          if (this.mpoll && !this.getCookie("poll_modal")) {
            promisses.push(
              this.requestPoll(this.mpoll.getAttribute("data-poll"))
                .then(function(data){
                  if (data.code !== "error") {
                    _this.events = _this.renderTemplate(data, _this.mpoll);
                  } else {
                    _this.mpoll = _this.mpoll.remove();
                    console.log("Warn Modal: ".concat(data.message));
                  }
                })
                .catch(function(error){
                  return console.log(error);
                })
            );
          }

          if (this.polls.length >= 1) {
            this.polls.forEach(function(poll){
              promisses.push(
                _this
                  .requestPoll(poll.getAttribute("data-poll"))
                  .then(function(data){
                    if (data.code !== "error") {
                      _this.events = _this.renderTemplate(data, poll);
                    } else {
                      console.log("Warn: ".concat(data.message));
                      poll.classList.add("poll-invalid"); // temp

                      poll.innerHTML = "".concat(data.message); // temp
                    }
                  })
                  .catch(function(error){
                    return console.log(error);
                  })
              );
            });
          }

          Promise.all(promisses).then(function(){
            if (_this.events) {
              _this.eventHandlers();
            }
          });
        }
      },
      {
        key : "requestPoll",
        value : function requestPoll(pollID){
          var _this2 = this;

          var getUrl = ""
            .concat(msdpoll.apiurl, "msd/polls/list/?id=")
            .concat(pollID);
          return new Promise(function(resolve, reject){
            if (!pollID) {
              reject("requestPoll: Empty or invalid poll ID.");
            }

            var self = _this2;
            var xhr = new XMLHttpRequest();
            xhr.open("GET", getUrl);
            xhr.send(null);

            xhr.onload = function(){
              if (this.status >= 200 && this.status < 400) {
                var json = JSON.parse(this.response);
                self.response[json.id] = json;
                resolve(json);
              } else {
                reject("Poll cannot be loaded.");
              }
            };
          });
        }
      },
      {
        key : "requestVote",
        value : function requestVote(choice){
          var _this3 = this;

          var voteOptions = {
            nonce : msdpoll.nonce,
            choice : choice.getAttribute("data-choice"),
            poll : choice.getAttribute("data-poll")
          };
          return new Promise(function(resolve, reject){
            var self = _this3;
            var xhr = new XMLHttpRequest();
            xhr.open("POST", "".concat(msdpoll.apiurl, "msd/polls/vote"));
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(JSON.stringify(voteOptions));

            xhr.onload = function(){
              var json = JSON.parse(this.response);
              self.response[json.poll] = json;

              if (this.status >= 200 && this.status < 400) {
                resolve(json);
              } else {
                reject(json);
              }
            };
          });
        }
      },
      {
        key : "renderTemplate",
        value : function renderTemplate(data, poll){
          var _this4 = this;

          var cookieLimit = this.getCookie("poll_limit_".concat(data.id)); // poll template

          poll.innerHTML = "\n\t\t\t<div id='"
            .concat(this.name.wrapper, "-")
            .concat(data.id, "' class=\"")
            .concat(this.name.wrapper, "\">\n\t\t\t\t<p class='")
            .concat(this.name.question, "'>")
            .concat(
              data.title,
              '</p>\n        <div id="results-poll" class="display_flex_mobile display_flex flex_direction_column_mobile flex_direction_column" style="display: none;">\n            <div id="poll-choices" class="display_flex_mobile display_flex justify_content_space_between_mobile justify_content_space_between" style="margin-bottom: 8px;">\n\n            </div>\n            <div id="poll-graph" class="display_flex_mobile display_flex" style="margin-bottom: 8px;">\n\n            </div>\n            <div id="poll-graph-value" class="display_flex_mobile display_flex justify_content_space_between_mobile justify_content_space_between" style="margin-bottom: 8px;">\n\n            </div>\n        </div>\n\t\t\t\t<ul class=\''
            )
            .concat(this.name.list, "'></ul>\n\t\t\t</div>\n\t\t\t<span class=\"")
            .concat(
              this.name.loader,
              '"><span class="spinner"></span></span>\n\t\t\t'
            )
            .concat(
              poll.id === this.name.modal
                ? '\n\t\t\t\t<span class="'.concat(
                this.name.closeButton,
                '"></span>\n\t\t\t'
                )
                : "",
              "\n\t\t"
            ); // add poll choices

          poll.list = poll.querySelector(".".concat(this.name.list));
          poll.choices_h4 = poll.querySelector("#poll-choices");
          data.answers.forEach(function(choice){
            var choiceEl = document.createElement("li");
            var choiceElH4 = document.createElement("h4");
            choiceElH4.innerHTML = '\n\t\t\t<h4 style="display: inline-block; font-size: 20px; margin: 0; padding: 0; text-transform: uppercase;">\n                '.concat(
              choice.answer,
              "\n       </h4>\n\t\t\t"
            );
            choiceEl.setAttribute("data-choice", choice.option);
            choiceEl.setAttribute("data-poll", data.id);
            choiceEl.innerHTML = "\n\t\t\t\t"
              .concat(
                data.has_image
                  ? "<span class='image'><img loading='lazy' src='"
                    .concat(choice.image, "' title='")
                    .concat(choice.answer, "' alt='")
                    .concat(choice.answer, "'></span>")
                  : "",
                "\n\t\t\t\t<strong><span class='answer'>"
              )
              .concat(choice.answer, "</span></strong>");

            if (!data.expired && !cookieLimit) {
              choiceEl.className = _this4.name.choice; // enable onclick event
            }

            poll.list.appendChild(choiceEl);
            poll.choices_h4.appendChild(choiceElH4);
          });

          if (data.expired || cookieLimit) {
            this.showResults(false, poll);
          }

          return true;
        }
      },
      {
        key : "eventHandlers",
        value : function eventHandlers(){
          var _this5 = this;

          this.element.choices = document.querySelectorAll(
            ".".concat(this.name.choice)
          );
          this.element.voteButton = document.querySelectorAll(
            ".".concat(this.name.voteButton)
          );
          this.element.viewButton = document.querySelectorAll(
            ".".concat(this.name.viewButton)
          );
          this.element.closeButton = document.querySelector(
            ".".concat(this.name.closeButton)
          ); // show / close modal poll

          if (this.mpoll && !this.getCookie("poll_modal")) {
            this.element.modal = document.getElementById(this.name.modal);
            this.element.modal.classList.add("active", "show");

            this.element.closeButton.onclick = function(){
              if (msdpoll.modaltime >= 1) {
                console.log("cookie created");

                _this5.createCookie("poll_modal", 1, msdpoll.modaltime);
              }

              _this5.element.modal.remove();
            };
          } // view poll results button and vote poll button (back from results)

          if (this.element.viewButton) {
            for (var i = 0; i < this.element.viewButton.length; i++) {
              this.element.viewButton[i].onclick = function(){
                return _this5.showResults(event, false);
              };

              this.element.voteButton[i].onclick = function(){
                return _this5.showPoll();
              };
            }
          } // vote events on poll choices

          for (var _i = 0; _i < this.element.choices.length; _i++) {
            this.element.choices[_i].addEventListener("click", this.submitVote);
          }
        }
      },
      {
        key : "submitVote",
        value : function submitVote(event){
          event.preventDefault();

          // do nothing if vote was previously submitted
          if (has_voted) {
              return; 
          } else {
              has_voted = true;
          }

          var t = event.currentTarget;
          var poll = t.closest(".".concat(this.name.parent));
          var poll_id = document.getElementById(poll.id);
          var poll_question = poll_id.querySelector(".poll-question").innerText;
          var poll_answer = t.querySelector(".answer").innerText;
          window[DATALAYER_NAME] = window[DATALAYER_NAME] || [];
          window[DATALAYER_NAME].push({
            event : "gaevent",
            eventCategory : "survey",
            eventAction : "answer",
            eventLabel : poll_question + "_" + poll_answer
          });
          this.togglePollLoader(poll, false);
          this.requestVote(t)
            .then(
              function(response){
                this.togglePollLoader(poll, true);
                this.handleMessage(poll, response.message, response.code);
                var answers = response.answers;
                var graphContent = "";
                poll.pollGraph = poll.querySelector("#poll-graph");
                poll.pollResult = poll.querySelector("#results-poll");
                poll.pollChoices = poll.querySelector(".poll-choices");
                poll.pollGraphValue = poll.querySelector("#poll-graph-value");

                for (var i = 0; i < answers.length; i++) {
                  var graphDiv = document.createElement("div");
                  var graphDivValue = document.createElement("h4");
                  var percent = answers[i]["percent"].toFixed(2) + "%";
                  graphDivValue.setAttribute(
                    "style",
                    "display: inline-block; font-size: 20px; margin: 0; padding: 0; text-transform: uppercase;"
                  );
                  graphDivValue.classList.add("poll-choice-graph-value");
                  graphDivValue.innerHTML = "\n                ".concat(
                    percent,
                    "\n\t\t\t      "
                  );
                  graphDiv.style.width = percent;
                  graphDiv.classList.add("poll-choice-graph");
                  graphDiv.style.height = "37px";
                  poll.pollGraph.appendChild(graphDiv);
                  poll.pollGraphValue.appendChild(graphDivValue);
                  poll.pollChoices.style.display = "none";
                  poll.pollResult.style.display = "block";
                }

                poll.classList.add("voted");

                if (response.code === "success") {
                  t.classList.add("choosed");
                } // set cookie for modal time if vote is from a modal

                if (poll.id === this.name.modal && msdpoll.modaltime >= 1) {
                  this.createCookie("poll_modal", 1, msdpoll.modaltime);
                } // remove list options if no results option is marked;

                if (typeof response.results != "undefined") {
                  poll.querySelector(".".concat(this.name.viewButton)).click();
                } else {
                  poll.querySelector(".".concat(this.name.list)).remove();
                }
              }.bind(this)
            )
            .catch(
              function(err){
                poll.classList.add("voted");
                this.togglePollLoader(poll, true);
                this.handleMessage(poll, err.message, "error");
              }.bind(this)
            );
        }
      },
      {
        key : "showResults",
        value : function showResults(event, poll){
          var _this6 = this;

          if (event) {
            event.preventDefault();
          }

          poll = event
            ? event.target.closest(".".concat(this.name.parent))
            : poll;
          var res = this.response[poll.getAttribute("data-poll")];
          poll.classList.add("view");
          poll.querySelector(".".concat(this.name.total, " span")).textContent =
            res.results.total;
          var choosedChoice = this.getCookie("poll_choice_".concat(res.id));

          if (choosedChoice) {
            poll
              .querySelector('li[data-choice="'.concat(choosedChoice, '"]'))
              .classList.add("choosed");
          }

          var choices = poll.querySelectorAll(".".concat(this.name.list, " li"));
          choices.forEach(function(choice, i){
            var votes = res.answers[i].votes;
            var percentFull = res.answers[i].percent;
            var percent = percentFull >= 1 ? percentFull.toFixed(2) + "%" : "0%";
            var result = ""
              .concat(votes, " ")
              .concat(msdpoll.labels.votes, " / ")
              .concat(percent);

            if (res.results.type == 2) {
              result = "".concat(votes, " ").concat(msdpoll.labels.votes);
            } else if (res.results.type == 1) {
              result = "".concat(percent);
            }

            choice.removeEventListener("click", _this6.submitVote); //choice.style.setProperty('--choicePercentage', `${percent}`);
            //choice.style.setProperty('--choiceResult', `"${result}"`);
            // choice.style.setProperty('width:', `${percent}`);
          });
        }
      },
      {
        key : "showPoll",
        value : function showPoll(){
          var _this7 = this;

          event.preventDefault();
          var t = event.target;
          var poll = t.closest(".".concat(this.name.parent));
          poll.classList.remove("view");
          var choices = poll.querySelectorAll(".".concat(this.name.choice));
          choices.forEach(function(choice){
            choice.addEventListener("click", _this7.submitVote);
            choice.classList.remove("choosed");
            choice.style.removeProperty("--choicePercentage");
            choice.style.removeProperty("--choiceResult");
            choice.style.removeProperty("width");
          });
        }
      },
      {
        key : "handleMessage",
        value : function handleMessage(poll, message, code){
          var e = poll.querySelector(".".concat(this.name.message));

          if (e) {
            e.classList.remove("error", "success", "warn", "not_allowed");
            e.classList.add(code);
            e.textContent = message;
          }
        }
      },
      {
        key : "togglePollLoader",
        value : function togglePollLoader(poll){
          var active =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : true;
          var removeClass, addClass;

          if (active) {
            removeClass = "loading";
            addClass = "active";
          } else {
            removeClass = "active";
            addClass = "loading";
          }

          poll.classList.remove(removeClass);
          poll.classList.add(addClass);
        }
      },
      {
        key : "getCookie",
        value : function getCookie(cname){
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(";");

          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == " ") {
              c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }

          return "";
        }
      },
      {
        key : "createCookie",
        value : function createCookie(name, value, hours){
          var expires;

          if (hours) {
            var now = new Date();
            now.setTime(now.getTime() + hours * 60 * 60 * 1000);
            expires = "; expires=" + now.toUTCString();
          } else {
            expires = "";
          }

          document.cookie = name + "=" + value + expires + "; path=/";
        }
      }
    ]);

    return msdAcfPoll;
  })(); // Initialize dynamic block preview (editor).

  var initializePoll = function initializePoll(){
    new msdAcfPoll();
  };

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=acf-poll", initializePoll);
  } else {
    new msdAcfPoll();
  }

});

/* eslint-enable */
